<template lang="pug">
header.d-flex.--center.Topbar(:class="class$",
    @click="open = false",
    @wheel.prevent.stop, @scroll.prevent.stop)
  nav.l-mw.d-flex.--middle(style="--gap-h: 24px")
    //- a(href="#intro"): img(:src="logoSrc")
    router-link.__logo(:to="ROUTES.INTRO"): Svgi(name="ohm-logo")

    template(v-for="item of nav")
      a.d-not-sm(v-if="item.external || ~item.route.substr(0, 2).indexOf('#')",
          :class="item.route === ROUTES.CONTACTS && '--contacts'", :href="item.route")
        |{{ item.name }}
      router-link.d-not-sm.__page(v-else, :to="item.route")
        |{{ item.name }}

    .d-flex__space

    a.__soc.d-flex.--cmid(v-for="(soc) in socs", :href="soc.url", target="_blank")
      Svgi(:name="soc.$svg")
      span.d-sm {{ soc.name }}

    button.d-sm(name="open-burger", @click.stop="open = !open"): Svgi(name="burger")

</template>
<script>
import content from 'content';
import ROUTES from 'routes';

import { onScroll, offScroll } from 'services/scroll';
import { cssVars, px } from 'common';

const FLATTEN_H = px(90);
const FULL_H = 'inherit';
// const GAP = window.innerHeight / 1.2;

export default {
  name: 'Topbar',
  inject: ['mq'],

  data: () => ({
    open: false,
    flatten: false,
  }),

  static: () => ({
    nav: content.nav,
    socs: content.socs,
    ROUTES,
  }),

  methods: {
    handleScroll (diff, { scrollTop }) {
      if (!diff)
        return;
      this.setFlatten(scrollTop > 30);
    },

    setFlatten (flatten) {
      if (this._flatten !== flatten) {
        cssVars.call(
          this.$el,
          { '--topb-h': flatten ? FLATTEN_H : FULL_H },
        );
        this._flatten = flatten;
      }
    },
  },

  computed: {
    class$ () {
      return [
        this.open && '--open',
      ];
    },
  },

  mounted () {
    this.gap = 0;
    onScroll(this.handleScroll);
  },

  unmounted () {
    offScroll(this.handleScroll);
  },
};

</script>
<style>
.Topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: var(--zi-topb);

  align-items: flex-end;
  height: var(--topb-h);
  padding: 0 var(--page-pad) 28px;

  background-color: var(--white);
  box-shadow: 0 4px 64px rgba(0, 0, 0, 0.07);

  transition: height .2s;

  --bb-blur: 6px;

  .__page {
    position: relative;

    box-shadow: 0 0 0 0 var(--accent-c) inset;

    transition: box-shadow .3s;

    &.router-link-active {
      /*box-shadow: 0 -2px 0 0 var(--accent-c) inset;*/
      &:after {
        position: absolute;
        right: 6px;
        bottom: -3px;
        left: 3px;

        height: 2px;

        background-color: var(--accent-c);
        border-radius: 6px;

        content: '';
      }
    }
  }

  a {
    white-space: nowrap;
    color: var(--black);
    font-weight: 500;
    font-size: 10px;
    letter-spacing: 0.3em;
    text-transform: uppercase;

    &.--contacts {
      position: relative;

      &:after {
        position: absolute;
        top: -7px;
        right: -12px;
        bottom: -7px;
        left: -12px;

        border: 1px solid #677b8c;

        content:  '';
      }
    }
  }

  .__logo svg {
    position: relative;
    bottom: 3px;

    width: 60px;
    height: 16px;
    color: var(--accent-c);
    margin-right: 20px;
  }

  .__soc {
    --gap-h: 16px;

    span { display: none }
    opacity: .4;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover { opacity: 1; }
  }
}

@media (min-width: 740px) {
  .Topbar {
    /*a.--contacts {
      padding: 7px 12px;

      white-space: initial;
      text-align: center;

      border: 1px solid #677b8c;
    }*/

    a.--contacts {
      margin-left: 7px;
    }
  }
}

@media (max-width: 739px) {
  .Topbar {
    align-items: center;
    padding: var(--page-pad);

    transition: height .2s;

    will-change: height;

    .__logo svg { bottom: unset }
    nav {
      align-items: center;
      height: 100%;
    }

    button[name="open-burger"] {
      position: absolute;
      right: var(--page-pad);

      padding: 12px;

      background: transparent;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;

        transition: transform .2s;
      }
    }

    .__soc { display: none; }
  }

  .Topbar.--open {
    align-items: flex-start;
    height: 100vh;

    nav {
      flex-direction: column;
      align-items: flex-start;
      padding-bottom: 80px;
    }

    .d-not-sm {
      display: block !important;
    }

    .__logo {
      margin-top: 16px;
      margin-bottom: 60px;
    }

    a {
      margin-bottom: 24px;
    }

    .__soc {
      display: flex;

      opacity: .7;

      span { display: inline; }
    }

    button[name="open-burger"] {
      svg {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
